module.exports = __webpack_public_path__ + "6a4b6dcdb458cc60aa2842ce80a426e9.pdf";